export enum Loading {
  NOT_LOADED,
  LOADING,
  SUCCESS,
  FAILURE
}
